/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Submissionnotfound2Inputs */

const en_questionnaire_submissionnotfound2 = /** @type {(inputs: Questionnaire_Submissionnotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submission not found`)
};

const fr_questionnaire_submissionnotfound2 = /** @type {(inputs: Questionnaire_Submissionnotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumission introuvable`)
};

/**
* | output |
* | --- |
* | "Submission not found" |
*
* @param {Questionnaire_Submissionnotfound2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_submissionnotfound2 = /** @type {((inputs?: Questionnaire_Submissionnotfound2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Submissionnotfound2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_submissionnotfound2(inputs)
	return fr_questionnaire_submissionnotfound2(inputs)
});
export { questionnaire_submissionnotfound2 as "questionnaire_submissionNotFound" }